import React from 'react';
import ReceiptResolutionWorkspace from './ReceiptResolutionWorkspace';

/** 수납결의승인 */
export default function ReceiptResolutionApprove() {
  return <ReceiptResolutionWorkspace screenMode="approve" />;
}
